function HomeAboutUs() {
    return (
        <div >
            <center><h3>About Us</h3></center>
            <p>The St. Louis Brews Homebrew Club is the oldest and largest club in the St. Louis area. 
            Our focus is towards education of beer styles and homebrewing techniques. At each meeting, 
            we focus on a small number of styles. Members bring beers of that style, and we evaluate 
            and compare them, giving the brewers plenty of feedback on how to make their beers even better. 
            We also try to have a tech topic at each meeting where we discuss brewing equipment and procedures.
            </p>
            <p>
                            We meet on the first Thursday of every month at 
                            St. James The Greater Early Childhood Development Center,
                            located at 1360 Tamm Ave, St. Louis, MO 63139.  Directions can be
                            found <a
                                href="https://www.google.com/maps/place/St.+James+the+Greater+Catholic+Church/@38.6258786,-90.2961797,16z/data=!3m1!4b1!4m6!3m5!1s0x87d8b5643198f213:0x56f4573220071d64!8m2!3d38.6258786!4d-90.2936048!16s%2Fg%2F1tgp1bmx?entry=ttu&g_ep=EgoyMDI1MTAxNC4wIKXMDSoASAFQAw%3D%3D">HERE</a>.

                            The meetings begin at 7:00pm and usually
                            finish around 10:00pm. We do allow visitors to join our meetings for a couple of times before we ask them to
                            join.
            The meetings begin at 7:00pm and usually finish around 10:00pm. We do allow visitors to join our meetings 
            for a couple of times before we ask them to join.
            </p>
        </div>
    );
}

export default HomeAboutUs;

